/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetImportRequestResponseDto
 */
export interface GetImportRequestResponseDto {
    /**
     * Import request ID
     * @type {string}
     * @memberof GetImportRequestResponseDto
     */
    id: string;
    /**
     * File type being imported
     * @type {string}
     * @memberof GetImportRequestResponseDto
     */
    fileType: GetImportRequestResponseDtoFileTypeEnum;
    /**
     * Current import status
     * @type {string}
     * @memberof GetImportRequestResponseDto
     */
    status: GetImportRequestResponseDtoStatusEnum;
    /**
     * Upload file ID
     * @type {string}
     * @memberof GetImportRequestResponseDto
     */
    uploadedFileId?: string;
    /**
     * Total assets successfully imported
     * @type {number}
     * @memberof GetImportRequestResponseDto
     */
    totalAssets?: number;
    /**
     * Validation/import report with errors and warnings
     * @type {object}
     * @memberof GetImportRequestResponseDto
     */
    report?: object;
    /**
     * Error message if status is FAILED
     * @type {string}
     * @memberof GetImportRequestResponseDto
     */
    error?: string;
    /**
     * Creation timestamp
     * @type {Date}
     * @memberof GetImportRequestResponseDto
     */
    createdAt: Date;
    /**
     * Last update timestamp
     * @type {Date}
     * @memberof GetImportRequestResponseDto
     */
    updatedAt: Date;
    /**
     * Uploaded file details
     * @type {object}
     * @memberof GetImportRequestResponseDto
     */
    uploadedFile?: object;
}


/**
 * @export
 */
export const GetImportRequestResponseDtoFileTypeEnum = {
    Asset: 'ASSET',
    AssetType: 'ASSET_TYPE',
    Component: 'COMPONENT',
    ComponentType: 'COMPONENT_TYPE',
    EventState: 'EVENT_STATE',
    ParameterName: 'PARAMETER_NAME',
    Subsystem: 'SUBSYSTEM',
    Report: 'REPORT'
} as const;
export type GetImportRequestResponseDtoFileTypeEnum = typeof GetImportRequestResponseDtoFileTypeEnum[keyof typeof GetImportRequestResponseDtoFileTypeEnum];

/**
 * @export
 */
export const GetImportRequestResponseDtoStatusEnum = {
    Pending: 'PENDING',
    AwaitingMapping: 'AWAITING_MAPPING',
    InProgress: 'IN_PROGRESS',
    Error: 'ERROR',
    Verified: 'VERIFIED',
    Success: 'SUCCESS',
    Failed: 'FAILED'
} as const;
export type GetImportRequestResponseDtoStatusEnum = typeof GetImportRequestResponseDtoStatusEnum[keyof typeof GetImportRequestResponseDtoStatusEnum];


/**
 * Check if a given object implements the GetImportRequestResponseDto interface.
 */
export function instanceOfGetImportRequestResponseDto(value: object): value is GetImportRequestResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('fileType' in value) || value['fileType'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function GetImportRequestResponseDtoFromJSON(json: any): GetImportRequestResponseDto {
    return GetImportRequestResponseDtoFromJSONTyped(json, false);
}

export function GetImportRequestResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetImportRequestResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fileType': json['fileType'],
        'status': json['status'],
        'uploadedFileId': json['uploadedFileId'] == null ? undefined : json['uploadedFileId'],
        'totalAssets': json['totalAssets'] == null ? undefined : json['totalAssets'],
        'report': json['report'] == null ? undefined : json['report'],
        'error': json['error'] == null ? undefined : json['error'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'uploadedFile': json['uploadedFile'] == null ? undefined : json['uploadedFile'],
    };
}

export function GetImportRequestResponseDtoToJSON(json: any): GetImportRequestResponseDto {
    return GetImportRequestResponseDtoToJSONTyped(json, false);
}

export function GetImportRequestResponseDtoToJSONTyped(value?: GetImportRequestResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fileType': value['fileType'],
        'status': value['status'],
        'uploadedFileId': value['uploadedFileId'],
        'totalAssets': value['totalAssets'],
        'report': value['report'],
        'error': value['error'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'uploadedFile': value['uploadedFile'],
    };
}

